module.exports = __webpack_public_path__ + "static/media/EW-welcome-banner.50285ac7.svg";